/**
 * Download
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides all helper functions related download functionalities.
 */

const downloadURI = (uri) => {
  window.open(uri, '_blank');
};

export default {
  downloadURI,
};
